import { Component, ChangeDetectionStrategy, computed, inject } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { SectionWrapperComponent } from '../section-wrapper/section-wrapper.component';
import { FeatureFlagService } from '../../services/feature-flag.service';
import { SiteConfigService } from '../../services/site-config.service';

@Component({
  selector: 'app-solution',
  imports: [SectionWrapperComponent, MatButtonModule, MatIconModule],
  templateUrl: './solution.component.html',
  styleUrl: './solution.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SolutionComponent {
  private readonly siteConfig = inject(SiteConfigService);
  private readonly featureFlags = inject(FeatureFlagService);

  readonly section = computed(() => {
    this.featureFlags.flags();
    const data = this.siteConfig.solution();
    if (!data) {
      return null;
    }
    return { ...data, items: this.featureFlags.filterItems(data.items) };
  });
}
